import { render } from "./PlanDetail.vue?vue&type=template&id=32900e10&scoped=true"
import script from "./PlanDetail.vue?vue&type=script&lang=js"
export * from "./PlanDetail.vue?vue&type=script&lang=js"

import "./PlanDetail.vue?vue&type=style&index=0&id=32900e10&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32900e10"]])

export default __exports__